export default __webpack_public_path__ + "static/logstore-35e618b98ea44e4f04f84e9dd2d79b68.svg";